<!-- ./src/pages/admin/Products.vue -->
<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 sm12 md10 offset-md1>
        <v-card>
          <v-card-title>
            Usuarios
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Buscar"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="usuarios"
            :search="search"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.username }}</td>
              <td>{{ props.item.acesso }}</td>
              <!--td class="text-xs-right">{{ props.item.width }}</td>
              <td class="text-xs-right">{{ props.item.height }}</td-->
              <td >
                <v-btn icon class="mx-0" @click="editItem(props.item)">
                  <v-icon color="teal">edit</v-icon>
                </v-btn>
                <v-btn icon class="mx-0" @click="deleteItem(props.item)">
                  <v-icon color="pink">delete</v-icon>
                </v-btn>
              </td>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
              Your search for "{{ search }}" found no results.
            </v-alert>
          </v-data-table>
          <v-btn
            absolute
            dark
            fab
            top
            right
            color="pink"
            @click="novo()"
          >
            <v-icon>add</v-icon>
          </v-btn>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialog" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Cadastrar Usuário</span>
        </v-card-title>
        <v-card-text>
          <form @submit.prevent="save()">
            <v-text-field
              label="Nome"
              v-model="model.name"
              required
            ></v-text-field>
            <v-text-field
              label="Email"
              v-model="model.username"
              required
            ></v-text-field>
            <v-text-field
              label="Password"
              type="password"
              v-model="model.senha"
              v-if="!editando"
              required
            ></v-text-field>
            <v-select
              :items="options"
              label="Acesso"
              v-model="model.acesso"
            ></v-select>
          </form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="clear()">Fechar</v-btn>
          <v-btn color="blue darken-1" flat @click.native="save()">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogConfirmation" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Confirmação</v-card-title>
        <v-card-text>Tem certeza que deseja excluir?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat @click.native="dialogConfirmation = false">Não</v-btn>
          <v-btn color="green darken-1" flat @click.native="deleteItem(excluindo)">Sim</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
  
</template>

<script>
import usuario from "@/services/usuario";

  export default {
    name: 'home',
    data () {
      return {
        search: '',
        snackbar: false,
        message: '',
        loading: true,
        dialog: false,
        dialogError: false,
        dialogConfirmation: false,
        editando: false,
        excluindo: {},
        idZabbix: '',
        usuarios: [],
        options: ['Admin'],
        model: {
          name: "",
          username: "",
          senha: ""
        },
        headers: [
          {
            text: 'Nome',
            align: 'left',
            sortable: true,
            value: 'name'
          },{
            text: 'Email',
            align: 'left',
            sortable: true,
            value: 'username'
          },{
            text: 'Acesso',
            align: 'left',
            sortable: true,
            value: 'acesso'
          },
          { text: 'Ações' }
        ]
      }
    },
    created () {
      usuario.getUsuarios().then((res) => {
        this.usuarios = res;
      });
    },
    methods: {
      novo: function () {
        this.dialog = true;
        this.model = {
          name: "",
          username: "",
          password: ""
        }
      },
      deleteItem: function (even) {
        if (!this.dialogConfirmation) {
          this.dialogConfirmation = true;
          this.excluindo = even;
        } else {
          usuario.deleteUser(even._id).then((res) => {
            this.dialogConfirmation = false;
            this.excluindo = null;
            usuario.getUsuarios().then((res) => {
              this.usuarios = res;
            });
          });
        }
      },
      editItem: function (even) {
        //this.$router.push({ name: 'EditGroupHosts', params: { id: even.groupid }})
        this.dialog = true;
        this.editando = true;
        this.model = even;
        this.model.internal = undefined;
        this.model.flags = undefined;
        /*zabbix.getGroupHostsId(this.$route.params.id).then((res) => {
          this.model = res;
          this.model.internal = undefined;
          this.model.flags = undefined;
        });*/
      },
      save: function () {
        this.$validator.validateAll().then((errors) =>  {
          if (errors) {
            if (this.editando) {
              usuario.alterarUsuario(this.model._id, this.model.acesso, this.model.name).then((res) => {
                if (res.data && res.data.error) {
                  this.message = res.data.error.data;
                  this.dialogError = true;
                } else {
                  this.clear();
                  usuario.getUsuarios().then((res) => {
                    this.usuarios = res;
                  });
                }
                
                this.editando = false;
              });
            } else {
              usuario.saveUsuario(this.model.name, this.model.username, this.model.senha, this.model.acesso).then((res) => {
                if (res.data && res.data.error) {
                  this.message = res.data.error.data;
                  this.dialogError = true;
                } else {
                  this.clear();
                  usuario.getUsuarios().then((res) => {
                    this.usuarios = res;
                  });
                }
                
                this.editando = false;
              });
            }
          }
        });
        
      },
      clear: function () {
        this.model = {
          name: "",
          username: "",
          password: ""
        }
        this.editando = false;
        this.$validator.reset()
        this.dialog = false;
      }

    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/user/Usuarios.vue